import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { Button, Card, Grid, Loader, Menu, Segment } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";
import { goToParent } from "@teamprevent/common/routing";

import { routeIdSelector as customerIdSelector } from "../../crud/customer/selectors";
import { routeIdSelector as employeeRecordIdSelector } from "../../crud/employeeRecord/selectors";
import { generalPractitionerSpecialistApi } from "../gpSpecialistInfoApi";
import { GPSpecialistInfo, gpSpecialistInfoIdSelector } from "../models";
import { basePathSelector, pathSelector } from "../selectors";

import { Edit } from "./Edit";

import { Fragment, Link } from "redux-little-router";

export const Details: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const path = useSelector(pathSelector);
    const basePath = useSelector(basePathSelector);
    const customerId = useSelector(customerIdSelector);
    const employeeRecordId = useSelector(employeeRecordIdSelector);
    const gpSpecialistInfoId = useSelector(gpSpecialistInfoIdSelector);

    const [loading, setLoading] = React.useState(false);
    const [model, setModel] = React.useState<GPSpecialistInfo>(null);

    React.useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            const detailsModel = await generalPractitionerSpecialistApi.get(customerId, employeeRecordId, gpSpecialistInfoId);
            setModel(detailsModel);
        };
        fetchData().then(() => setLoading(false));
    }, [customerId, employeeRecordId, gpSpecialistInfoId]);

    const afterEdit = (updatedModel: GPSpecialistInfo) => setModel(updatedModel);

    const onClose = () => dispatch(goToParent());

    const onDelete = async () => {
        await generalPractitionerSpecialistApi.deleteRecord(customerId, employeeRecordId, gpSpecialistInfoId);
        onClose();
    };

    if (loading) {
        return <Loader active />;
    }

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column width={3} as={Grid} padded>
                        <Grid.Column vertical as={Menu}>
                            <Menu.Item as={Link} href={basePath}>
                                All GP/Specialist Info
                            </Menu.Item>
                        </Grid.Column>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Card fluid>
                            <Segment attached>
                                <Grid>
                                    <Detail label="Name" value={model?.name} />
                                    <Detail label="Surgery name" value={model?.surgeryName} />
                                    <Detail label="Surgery address &amp; postcode" value={model?.surgeryAddressAndPostcode} />
                                    <Detail label="Telephone number" value={model?.telephoneNumber} />
                                    <Detail label="Email" value={model?.emailAddress} />
                                    <Detail label="Type" value={model?.type} />
                                </Grid>
                            </Segment>
                            <Segment attached>
                                <ConfirmedButton
                                    icon="delete"
                                    content="Delete"
                                    floated="left"
                                    className="warning"
                                    onClick={onDelete}
                                    promptText="Are you sure you want to delete this GP/Specialist Info record? Type 'DELETE' and click confirm to delete."
                                    typeToConfirmText="DELETE"
                                    headingText="Delete GP/Specialist Info  Record"
                                />
                                <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${path}/edit`} />
                            </Segment>
                        </Card>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Fragment forRoute="/edit">
                <Edit gpSpecialistInfo={model} afterEdit={afterEdit} />
            </Fragment>
        </>
    );
};
